export default "__VITE_ASSET__CWD5BIOc__"